import { defineComponent as _defineComponent } from 'vue';
import { ref } from 'vue';
import { VAlert, VContainer, VRow, VCol, VSimpleTable } from "vuetify/lib";
import DemoSection from "@/components/DemoSection.vue";
import CodePreview from "@/components/CodePreview.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'BeosTableDemo',
    setup(__props) {
        const selectedItems = ref([]);
        const selectedTableColumns = ref([
            { name: 'ID', value: 'id' },
            { name: 'Nombre', value: 'name' },
            { name: 'Edad', value: 'age' },
        ]);
        const columnPickerOptions = ref([
            { name: 'ID', value: 'id' },
            { name: 'Nombre', value: 'name' },
            { name: 'Edad', value: 'age' },
            { name: 'Ciudad', value: 'city' },
            { name: "All", value: "*" }
        ]);
        const headers = ref([
            { text: 'ID', value: 'id', width: '100px', sortable: false },
            { text: 'Nombre', value: 'name' },
            { text: 'Edad', value: 'age', width: '100px', sortable: false },
            { text: 'Ciudad', value: 'city', sortable: false },
        ]);
        const multiSortHeaders = ref([
            { text: 'ID', value: 'id', width: '100px' },
            { text: 'Nombre', value: 'name' },
            { text: 'Edad', value: 'age', width: '100px' },
            { text: 'Ciudad', value: 'city' },
        ]);
        const plainMultiSortOptions = ref({
            page: 1,
            itemsPerPage: 10,
            sortBy: [],
            sortDesc: [],
        });
        const multiSortOptions = ref({
            page: 1,
            itemsPerPage: 10,
            sortBy: [],
            sortDesc: [],
        });
        const items = ref([
            { id: 1, name: 'Juan Pérez', age: 30, city: 'Madrid' },
            { id: 2, name: 'María García', age: 25, city: 'Barcelona' },
            { id: 3, name: 'Carlos López', age: 35, city: 'Valencia' },
            { id: 4, name: 'Ana Martín', age: 28, city: 'Sevilla' },
            { id: 5, name: 'Pedro Sánchez', age: 40, city: 'Bilbao' },
            { id: 6, name: 'Laura Díaz', age: 32, city: 'Zaragoza' },
            { id: 7, name: 'Miguel Ruiz', age: 29, city: 'Málaga' },
            { id: 8, name: 'Carmen Jiménez', age: 33, city: 'Murcia' },
        ]);
        const toggleSelection = (id) => {
            const index = selectedItems.value.indexOf(id);
            if (index > -1) {
                selectedItems.value.splice(index, 1);
            }
            else {
                selectedItems.value.push(id);
            }
        };
        return { __sfc: true, selectedItems, selectedTableColumns, columnPickerOptions, headers, multiSortHeaders, plainMultiSortOptions, multiSortOptions, items, toggleSelection, VAlert, VContainer, VRow, VCol, VSimpleTable, DemoSection, CodePreview };
    }
});
